// extracted by mini-css-extract-plugin
var _1 = "OverviewApprovalSubtitle-moduleOverviewApprovalSubtitle__LsdbA";
var _2 = "OverviewApprovalSubtitle-moduleselected__Ca5EQ";
var _3 = "OverviewApprovalSubtitle-moduleunit__KmEQv";
export { _1 as "OverviewApprovalSubtitle", _2 as "selected", _3 as "unit" }
